/**
 * @generated SignedSource<<c1d8acae13ad24ca651f8c0cdbfd7b4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FindAvailabilityConfigInput = {
  practitionerUserId: string;
};
export type userAvailabilitiesConfigRefetchableQuery$variables = {
  input: FindAvailabilityConfigInput;
};
export type userAvailabilitiesConfigRefetchableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"userAvailabilityConfigQueryFragment">;
};
export type userAvailabilitiesConfigRefetchableQuery = {
  variables: userAvailabilitiesConfigRefetchableQuery$variables;
  response: userAvailabilitiesConfigRefetchableQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userAvailabilitiesConfigRefetchableQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "userAvailabilityConfigQueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userAvailabilitiesConfigRefetchableQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "UserAvailabilityConfig",
        "kind": "LinkedField",
        "name": "findAvailabilityConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25f15c884106543102f0a863583ad291",
    "id": null,
    "metadata": {},
    "name": "userAvailabilitiesConfigRefetchableQuery",
    "operationKind": "query",
    "text": "query userAvailabilitiesConfigRefetchableQuery(\n  $input: FindAvailabilityConfigInput!\n) {\n  ...userAvailabilityConfigQueryFragment\n}\n\nfragment userAvailabilityConfigFragment on UserAvailabilityConfig {\n  id\n  duration\n}\n\nfragment userAvailabilityConfigQueryFragment on Query {\n  findAvailabilityConfig(input: $input) {\n    ...userAvailabilityConfigFragment\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd26e5364d49c074b43ee381adc1b287";

export default node;
